module.exports = __webpack_public_path__ + "static/media/placeholder.86d14ad8.png";